import { request } from './instance';
export const SecondaryFormatAPI = {
  getAll: async () => {
    const response = await request({
      url: 'v1/secondary_formats',
      method: 'GET',
    });

    return response.data.data;
  },
};
